module.exports = __webpack_public_path__ + "fonts/font01-Bold.c1da6f4e.woff2";